import type { InjectionKey } from 'vue'
import {
  type MeasureRights,
  MeasureSortField,
  MeasureStatus,
  MeasuresDatatableColumnId,
  type Policy,
  RecurringControlType,
} from '@/contexts/security-base/SecurityBase.interfaces'
import { NdsTagColor } from '@/components/NewDesignSystem/NdsTag/NdsTag.interfaces'
import {
  DatatableSortingOrderBy,
  type DatatableSorting,
} from '@/components/NewDesignSystem/NdsDatatable/NdsDatatable.interfaces'

export const MEASURE_STATUS = {
  ...MeasureStatus,
}

export const MEASURE_SORT_FIELD = {
  ...MeasureSortField,
}

export const MEASURE_SORT_FIELD_BY_COLUMN_ID: Readonly<Partial<Record<MeasuresDatatableColumnId, MeasureSortField>>> = {
  [MeasuresDatatableColumnId.NAME]: MEASURE_SORT_FIELD.NAME,
  [MeasuresDatatableColumnId.IDENTIFIER]: MEASURE_SORT_FIELD.IDENTIFIER,
  [MeasuresDatatableColumnId.STATUS]: MEASURE_SORT_FIELD.STATUS,
  [MeasuresDatatableColumnId.PERIMETER]: MEASURE_SORT_FIELD.PERIMETER_NAME,
  [MeasuresDatatableColumnId.RISKS]: MEASURE_SORT_FIELD.RISK_COUNT,
  [MeasuresDatatableColumnId.ACTIONS]: MEASURE_SORT_FIELD.ACTION_COUNT,
  [MeasuresDatatableColumnId.EFFICIENCY]: MEASURE_SORT_FIELD.EFFICIENCY,
}

export const DEFAULT_MEASURES_SORTING: Readonly<DatatableSorting> = {
  columnId: MeasuresDatatableColumnId.NAME,
  orderBy: DatatableSortingOrderBy.ASC,
}

export const RECURRING_CONTROL_TYPE = {
  ...RecurringControlType,
}

export const MEASURE_RIGHTS: Readonly<Record<string, keyof MeasureRights>> = {
  CHANGE_STATUS: 'change_status',
  EDIT_BUILT_MEASURE: 'edit_built_measure',
  EDIT: 'edit',
  DELETE: 'delete',
}

export const MEASURE_STATUS_TRANSLATION_KEY: Readonly<Record<MeasureStatus, string>> = {
  [MEASURE_STATUS.TO_IMPLEMENT]: 'security_base.measure.status.to_implement',
  [MEASURE_STATUS.NOT_IMPLEMENTED]: 'security_base.measure.status.not_implemented',
  [MEASURE_STATUS.IMPLEMENTED]: 'security_base.measure.status.implemented',
}

export const MEASURE_STATUS_TAG_COLOR: Readonly<Record<MeasureStatus, NdsTagColor>> = {
  [MEASURE_STATUS.TO_IMPLEMENT]: NdsTagColor.NEUTRAL,
  [MEASURE_STATUS.NOT_IMPLEMENTED]: NdsTagColor.WARNING,
  [MEASURE_STATUS.IMPLEMENTED]: NdsTagColor.SUCCESS,
}

export const MEASURES_FILTERS_ID: Readonly<Record<string, string>> = {
  STATUS: 'status',
  IMPLEMENTED_BY: 'implemented-by',
  ACTIONS: 'actions',
  RISKS: 'risks',
  EFFICIENCY: 'efficiency',
  SCORE: 'score',
}

export const MEASURES_FILTERS_ACTIONS: Readonly<Record<string, string>> = {
  WITH_ACTIONS: 'with-actions',
  WITHOUT_ACTIONS: 'without-actions',
}

export const MEASURES_FILTERS_RISKS: Readonly<Record<string, string>> = {
  WITH_RISKS: 'with-risks',
  WITHOUT_RISKS: 'without-risks',
}

export const MEASURES_FILTERS_SCORE: Readonly<Record<string, string>> = {
  DEFAULT: 'default',
  WITH_CONTROLS: 'with-controls',
}

export const IMPACT_OPTIONS = {
  NEUTRAL: 'NEUTRAL',
  MINOR: 'MINOR',
  MAJOR: 'MAJOR',
  CUSTOM: 'CUSTOM',
}

export const IMPACT_BY_OPTIONS: Record<string, number> = {
  [IMPACT_OPTIONS.NEUTRAL]: 0,
  [IMPACT_OPTIONS.MINOR]: 25,
  [IMPACT_OPTIONS.MAJOR]: 50,
}

export const OPEN_REMOVE_POLICY_MODAL_KEY: InjectionKey<(policy: Policy) => void> = Symbol('openRemovePolicyModal')

export const SECURITY_BASE_ROUTE_NAMES: Record<string, string> = {
  MEASURES: 'security_base_measures',
  PERIMETERS: 'security_base_perimeters',
  POLICIES: 'security_base_policies',
  MEASURES_DIFFERENCES: 'security_base_measures_differences',
}
